module.exports = __webpack_public_path__ + "img/history-two.3ca7de49.png";